const BASE_URL: string = process.env.REACT_APP_PUBLIC_URL || ".";
const SHOW_PAGE: boolean = process.env.REACT_APP_SHOW_PAGE === "true" || false;

const Config = {
  BASE_URL,
  SHOW_PAGE,
};

export default Config;
